import { InvestmentTypeEnum } from "gen/model/investmentTypeEnum";
import { useTranslation } from "react-i18next";
import { FormSelect } from "shared/components/input/select/Select";
import { SelectOption } from "shared/components/input/select/SelectOption";
import { enumKeys } from "shared/utils/EnumUtils";

export const InvestmentTypeFormSelect: React.FC<{
  name: string;
  unsetWhenEmpty?: boolean;
}> = ({ name, unsetWhenEmpty = false }) => {
  const { t } = useTranslation(["investment", "enums"]);
  return (
    <FormSelect
      name={name}
      title={t("investment:investmentType")}
      unsetWhenEmpty={unsetWhenEmpty}
    >
      {enumKeys(InvestmentTypeEnum).map((investment_type_enum) => (
        <SelectOption
          key={`investment_type_${investment_type_enum}`}
          value={investment_type_enum}
        >
          {t(`enums:InvestmentTypeEnum.${investment_type_enum}`)}
        </SelectOption>
      ))}
    </FormSelect>
  );
};
